import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';

import { pageTransitions } from '../../../shared/animations/page-transitions';
import { LoadingSpinnerComponent } from '../../../shared/components/utils/loading-spinner.component';

@Component({
	selector: 'copo-check-offer-widget',
	templateUrl: './check-offer-widget.component.html',
	styleUrl: './check-offer-widget.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,

	imports: [NgIf, TranslateModule, MatButtonModule, RouterLink, MatIconModule, LoadingSpinnerComponent]
})
export class CheckOfferWidgetComponent {
	@Input() headerLabel!: string;
	@Input() btnLabel!: string;
	@Input() btnRouterLink!: string;
	isLoading = false;
}
